// extracted by mini-css-extract-plugin
export default {"btnSpacer":"AddTask_btnSpacer__O0hta","inputField":"AddTask_inputField__gTy04"};